// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/registry.npmmirror.com+css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user_list_page .header[data-v-4eb3307e] {\n  height: 50px;\n  font-size: 24px;\n  font-weight: 500;\n  border-bottom: 1px solid #eee;\n  margin-left: 5px;\n}\n.user_list_page .list_button[data-v-4eb3307e] {\n  width: 80px;\n  height: 30px;\n  line-height: 30px;\n  text-align: center;\n  border: none;\n  color: #fff;\n  font-size: 12px;\n  border-radius: 5px;\n  margin-right: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
